module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_0.a175737e.png";